import { APP_COLOR } from '@/theme/color';
import { Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface LivesIndicatorProps {
  readonly lives: number;
  readonly totalLives?: number;
}

export function LivesIndicator({ lives, totalLives = 3 }: LivesIndicatorProps) {
  const { t } = useTranslation();

  return (
    <div
      className="flex h-[38px] shrink-0 items-center justify-center gap-[7px] rounded-full border px-[14px]"
      style={{ borderColor: '#ffffff96', background: '#ffffff2e' }}
      aria-label={t('hud.livesLabel', { lives, totalLives })}
    >
      {Array.from({ length: totalLives }, (_, index) => {
        const isRemaining = index < lives;
        return (
          <Heart
            key={index}
            size={18}
            fill={isRemaining ? APP_COLOR.accentBright : 'none'}
            stroke={isRemaining ? APP_COLOR.accentBright : 'rgba(255,255,255,0.4)'}
            aria-hidden="true"
          />
        );
      })}
    </div>
  );
}
